import * as React from 'react';
import '../Campaign.css';
import { Link } from 'react-router-dom';
import {Campaign} from '../../../_models/Campaign'
import { toast } from 'react-toastify';
//import * as controller from '../controller'
import { withLocalize, Translate} from "react-localize-redux";
import BarGraph from '../../user/bar.jsx'
import PieGraph from '../../user/pie.jsx'

class StatsPage extends React.Component<any, any> {
  grid: any
  constructor(props: any) {
    super(props);
    this.state = {
      campaign: new Campaign(),
    }
  }



  componentDidMount() {
    if(this.props.match.params.id && !isNaN(this.props.match.params.id)) {
      this.loadCampaign(this.props.match.params.id)
    }

  }




  loadCampaign(id:any) {
    fetch('campaigns/stats', {
      method: 'POST',
      body: JSON.stringify({id})
    }).then(results => {
      return results.json();
    }).then(data => {
        let campaign = new Campaign(data.campaign)
        this.setState({campaign})
    }).catch(err => {
      toast.error(err.message);
    })
  }




  public render() {
    let campaign = this.state.campaign
    let maleFollowers = 0
    let israeliFollowers = 0
    let ghostFollowers = 0
    let teenagersFollowers = 0
    let studentFollowers = 0
    let youngFollowers = 0
    let adultFollowers = 0
    let oldFollowers = 0
    let followers = 0
    let views = 0
    let likes = 0
    let videoViews = 0
    let comments = 0

    campaign.users.map((user: any) => {

      if(user.participating) {
        maleFollowers += user.maleFollowers
        israeliFollowers += user.israeliFollowers
        ghostFollowers += user.ghostFollowers
        teenagersFollowers += user.teenagersFollowers
        studentFollowers += user.studentFollowers
        youngFollowers += user.youngFollowers
        adultFollowers += user.adultFollowers
        oldFollowers += user.oldFollowers
        followers += user[campaign.mediaType+"Followers"],
        likes += user.likes,
        views += user.views,
        videoViews += user.videoViews,
        comments += user.comments
      }
    })

    if(campaign.users.length > 0) {
      maleFollowers /= campaign.users.length
      israeliFollowers /= campaign.users.length
      ghostFollowers /= campaign.users.length
      teenagersFollowers /= campaign.users.length
      studentFollowers /= campaign.users.length
      youngFollowers /= campaign.users.length
      adultFollowers /= campaign.users.length
      oldFollowers /= campaign.users.length
    }



    return (
      <div id="edit-campaign-root" className="stats" style={{paddingTop: 0}}>

      <div style={{direction: "ltr", marginTop: 0}} className="graphs">
      <Link to="/campaigns"><i style={{marginTop: 10}} className="fas fa-times"></i></Link>

      <h2 className="sectionHeader big"><Translate id="campaign.statisticsCampaign" /> {campaign.title}</h2>




      <h4><Translate id="campaign.comments" /><span>{comments.toLocaleString('us-EN')}</span></h4>
      <h4><Translate id="campaign.videoViews" /><span>{videoViews.toLocaleString('us-EN')}</span></h4>
      <h4><Translate id="campaign.views" /><span>{views.toLocaleString('us-EN')}</span></h4>
      <h4><Translate id="campaign.likes" /><span>{likes.toLocaleString('us-EN')}</span></h4>
      <h4><Translate id="followers" /><span>{followers.toLocaleString('us-EN')}</span></h4>
      <h2 className="sectionHeader"><Translate id="campaign.statisticsInfluencers" /></h2>
          <div className="graph">
            <h4><Translate id="campaign.followersSex" /></h4>
            <PieGraph  data={[
              {name: this.props.translate("male").toString(), value: maleFollowers, fill: '#2f98e0'},
              {name: this.props.translate("female").toString(), value: 100-maleFollowers ,fill: '#fdb8f9'}
            ]}/>
          </div>

          <div className="graph">
            <h4><Translate id="campaign.followersOrigin" /></h4>
            <PieGraph data={[
              {name: this.props.translate("israelis").toString(), value: israeliFollowers, fill: '#2f98e0'},
              {name: this.props.translate("foreign").toString(), value: 100-israeliFollowers ,fill: '#9ad2f9'}
            ]}/>
          </div>

          <div className="graph">
            <h4><Translate id="campaign.inactiveFllowers" /></h4>
            <PieGraph data={[
              {name: 'Ghost', value: ghostFollowers, fill: '#ccc'},
              {name: this.props.translate("active").toString(), value: 100-ghostFollowers ,fill: '#2f98e0'}
            ]}/>
          </div>

          <div className="graph">
            <h4><Translate id="campaign.followersAges" /></h4>
            <BarGraph data={[
                  {name: '<18', "%": teenagersFollowers},
                  {name: '19-24', "%": studentFollowers},
                  {name: '25-34', "%": youngFollowers},
                  {name: '35-45', "%": adultFollowers},
                  {name: '45+', "%": oldFollowers}
                ]} />
          </div>

          <div className="clearfix"></div>
      </div>
      <div className="grid" ref={(elm:any)=>{this.grid=elm}}>
          {campaign.users.map((user: any) => {
            if(user.participating) {
              return user.links.map((link: any, i:number) => {
                return link.link? (
                  <a target="_blank" href={link.link} key={i} className="grid-item flip-container">
                      <div className="flipper">
                        <div className="front" style={{backgroundImage: "url("+link.image+")"}}></div>
                        <div className="back">
                          <div className="border"></div>
                          <div className="userImage" style={{backgroundImage: "url("+process.env.REACT_APP_AWS+"/users/"+user.id+"/pictures/"+user.picture+")"}}></div>
                          <h5>{user.name}</h5>
                          <span><i className="fas fa-thumbs-up"></i>{parseInt(link.likes).toLocaleString('us-EN')}</span>
                          <span><i className="fas fa-comment"></i>{parseInt(link.comments).toLocaleString('us-EN')}</span>
                        </div>
                      </div>
                    </a>
                ) : (
                  <div style={{display: "none"}}></div>
                )
              })
            }
          })}
          </div>
          <div className="clearfix"></div>
      </div>
    )
  }
}

export default withLocalize(StatsPage)



// WEBPACK FOOTER //
// ./src/pages/campaign/stats/Stats.tsx